<template>
  <div>
    <label>Modalidad</label>
    <b-skeleton-wrapper :loading="loader">
      <template #loading>
        <b-skeleton
          type="button"
          width="100%"
          class="mb-75"
        />
      </template>
      <div class="mb-75">
        <v-select
          id="modalidad"
          placeholder="Seleccione una modalidad"
          label="tipo"
          :reduce="modalidad => modalidad.id"
          :value="modalidad"
          :options="modalidades"
          :clearable="false"
          @input="val => $emit('tipomodalidad', val)"
        />
      </div>
    </b-skeleton-wrapper>
  </div>
</template>
<script>
import {
  BSkeletonWrapper,
  BSkeleton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, onMounted } from '@vue/composition-api'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    vSelect,
    BSkeletonWrapper,
    BSkeleton,
  },
  props: {
    modalidad: {
      type: [Number, null],
      default: null,
    },
  },
  setup(_, { emit }) {
    const modalidades = ref([])
    const toast = useToast()
    const loader = ref(false)
    const loadModalidades = () => {
      loader.value = true
      getData({ action: 47 }, 'wspublico')
        .then(response => {
          loader.value = false
          if (response.status === 200) {
            modalidades.value = response.data.modalidad || []
            emit('catalogomodalidad', modalidades.value)
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error cargando modalidades',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
        }, error => {
          loader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando modalidades',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    onMounted(() => {
      loadModalidades()
    })
    return {
      modalidades,
      loader,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
